var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"20px"}},[_vm._v(" 欢迎使用本系统 ")])}
var staticRenderFns = []

export { render, staticRenderFns }